import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { getaccountType } from "../../../../store/slices/accountType";
import { getBankListSlice } from "../../../../store/slices/bankSlice";
import {
  getPhysicianPaymentData,
  doPhyisicianPayment,
  resetMessage,
} from "../../../../store/slices/physicianPaymentSlice";
import { useLocation } from "react-router-dom";
import ShowTostifyMessageAndReset from "../../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../../common/tostify/Toastifyresponse";
const PhysicianPaymentHistory = () => {
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedAccountType, setSelectedAccountType] = useState(null);
  const [filteredBanks, setFilteredBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const physicianName = sessionStorage.getItem("physicianName") || "NA";
  const { accountType } = useSelector((state) => state.accountType);
  const { bank } = useSelector((state) => state.bank);
  const { physicianPaymentData, successMessage, errorMessage } = useSelector(
    (state) => state.paymentHistory
  );
  const location = useLocation();
  const physicianId = location.state?.physicianId;
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
 const clinicId =clinicInfo?.[0]?.clinicId ||null;
  useEffect(() => {
    dispatch(getaccountType({ status: ["Active"], token }));
    dispatch(getBankListSlice({ clinicId, token }));
    dispatch(
      getPhysicianPaymentData({
        clinicId,
        physicianId: physicianId,
        token,
      })
    );
  }, [dispatch, clinicId, token]);

  useEffect(() => {
    showTostifyMessageAndReset(
      successMessage,
      showToastifySuccess,
      resetMessage
    );
    showTostifyMessageAndReset(errorMessage, showToastifyError, resetMessage);
  }, [successMessage, errorMessage, showTostifyMessageAndReset]);

  useEffect(() => {
    if (selectedAccountType) {
      const filtered = bank?.filter(
        (b) => b.accountType?._id === selectedAccountType.value
      );
      setFilteredBanks(
        filtered?.map((b) => ({
          value: b._id,
          label: b.name,
        })) || []
      );
      setSelectedBank(null);
    } else {
      setSelectedBank(null);
    }
  }, [selectedAccountType, bank]);

  const handleRowCheck = (rowKey) => {
    const [i, j] = rowKey.split("-").map(Number);
    const payment = physicianPaymentData?.[i]?.payments?.[j];
  
    if (physicianPaymentData?.payment?.status === "PAID") return; // Prevent selecting paid rows
  
    let updatedSelectedRows = [...selectedRows];
  
    if (updatedSelectedRows.includes(rowKey)) {
      updatedSelectedRows = updatedSelectedRows.filter((i) => i !== rowKey);
    } else {
      updatedSelectedRows.push(rowKey);
    }
  
    setSelectedRows(updatedSelectedRows);
  
    const totalPayments = physicianPaymentData?.reduce(
      (acc, data) =>
        acc + data?.payments?.filter((p) => p.status !== "PAID")?.length,
      0
    );
  
    setCheckAll(updatedSelectedRows.length === totalPayments);
    calculateTotalAmount(updatedSelectedRows);
  };
  

  const handleCheckAll = () => {
    if (checkAll) {
      setSelectedRows([]);
      setTotalAmount(0);
    } else {
      const allKeys = [];
      physicianPaymentData?.forEach((dataItem, i) => {
        dataItem?.payments?.forEach((p, j) => {
          if (p.status !== "PAID") {
            allKeys.push(`${i}-${j}`);
          }
        });
      });
  
      setSelectedRows(allKeys);
      calculateTotalAmount(allKeys);
    }
  
    setCheckAll(!checkAll);
  };
  

  const calculateTotalAmount = (selectedKeys) => {
    let total = 0;
    selectedKeys.forEach((key) => {
      const [i, j] = key.split("-").map(Number);
      const payment = physicianPaymentData?.[i]?.payments?.[j];
      const consultationFee = payment?.appointmentId?.totalAmount || 0;
      const establishmentFee =
        payment?.physicianId?.asociatedClinic?.[0]?.establishmentFees || 0;

      total += consultationFee - establishmentFee;
    });

    setTotalAmount(total);
  };

  const tableHeaders = [
    "App Date",
    "Consultation Fee",
    "Establishment Fee",
    "Total Fee",
    "Status",
  ];

  const handlePayment = () => {
    if (!selectedRows.length) {
      showToastifyError("Please select at least one appointment.");
      return;
    }

    if (!selectedBank || !selectedAccountType) {
      showToastifyError("Please select both Bank and Account Type.");
      return;
    }

    const appointmentIds = [];
    const invoiceIds = [];

    selectedRows.forEach((key) => {
      const [i, j] = key.split("-").map(Number);
      const payment = physicianPaymentData?.[i]?.payments?.[j];

      if (payment?.appointmentId?._id) {
        appointmentIds.push(payment?.appointmentId?._id);
      }
      if (payment?.invoiceId?._id) {
        invoiceIds.push(payment?.invoiceId?._id);
      }
    });

    const paymentData = {
      clinicId: clinicInfo[0]?.clinicId,
      physicianId,
      appointmentId: appointmentIds,
      invoiceId: invoiceIds,
      bank: selectedBank.value,
      accountType: selectedAccountType.value,
      paidAmount: totalAmount,
      totalPrice: totalAmount,
      receivedBy: clinicInfo[0]?.userId?._id,
      createdBy: clinicInfo[0]?.userId?._id,
      token,
    };

    dispatch(doPhyisicianPayment(paymentData));
  };

  return (
    <>
      <div className="card-body">
        <div className="row">
          <div className="col-md-3">
            <div className="form-group form-focus focused">
              <label className="focus-label">From</label>
              <div className="cal-icon">
                <input
                  className="form-control floating datetimepicker"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group form-focus focused">
              <label className="focus-label">To</label>
              <div className="cal-icon">
                <input
                  className="form-control floating datetimepicker"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3 mt-4">
            <button className="btn btn-primary">Filter</button>
          </div>
        </div>

        <div className="card mt-4">
          <div className="card-body">
            <div className="basic-form">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                  <div className="form-group mb-3 col-md-6">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={physicianName}
                      readOnly
                    />
                  </div>
                  <div className="form-group mb-3 col-md-6">
                    <label>Total Payment</label>
                    <input
                      type="text"
                      className="form-control"
                      value="3500"
                      readOnly
                    />
                  </div>
                  <div className="form-group mb-3 col-md-6">
                    <label className="col-form-label">Account Type:</label>
                    <Select
                      placeholder="Select Account Type"
                      options={accountType?.map((account) => ({
                        value: account?._id,
                        label: account?.name,
                      }))}
                      onChange={(selectedOption) =>
                        setSelectedAccountType(selectedOption)
                      }
                    />
                  </div>
                  <div className="form-group mb-3 col-md-6">
                    <label className="col-form-label">Bank:</label>
                    <Select
                      placeholder="Select Bank"
                      value={selectedBank}
                      options={filteredBanks}
                      onChange={(selectedOption) =>
                        setSelectedBank(selectedOption)
                      }
                      isDisabled={!selectedAccountType}
                    />
                  </div>

                  <div className="card mt-4">
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={checkAll}
                                  onChange={handleCheckAll}
                                  disabled={physicianPaymentData?.payment?.status === "PAID"}
                                />
                                <span> Check All</span>
                              </th>
                              {tableHeaders.map((header, index) => (
                                <th key={index}>{header}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {physicianPaymentData?.flatMap((dataItem, i) =>
                              dataItem?.payments?.map((payment, index) => (
                                <tr key={`${i}-${index}`}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedRows.includes(
                                        `${i}-${index}`
                                      )}
                                      onChange={() =>
                                        handleRowCheck(`${i}-${index}`)
                                      }
                                      disabled={payment?.status === "PAID"}
                                    />
                                  </td>
                                  <td>
                                    {payment?.appointmentId?.appDate || "N/A"}
                                  </td>
                                  <td>
                                    {payment?.appointmentId?.totalAmount || 0}
                                  </td>
                                  <td>
                                    {payment?.physicianId?.asociatedClinic?.[0]
                                      ?.establishmentFees || 0}
                                  </td>
                                  <td>
                                    {(payment?.appointmentId?.totalAmount ||
                                      0) -
                                      (payment?.physicianId
                                        ?.asociatedClinic?.[0]
                                        ?.establishmentFees || 0)}
                                  </td>
                                  <td>{payment?.status}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex justify-content-end align-items-center mt-3">
                        <label className="me-2 fw-bold">Total Amount:</label>
                        <input
                          type="text"
                          className="form-control me-3"
                          style={{ width: "150px", height: "30px" }}
                          value={totalAmount}
                          readOnly
                        />
                      </div>

                      <div className="d-flex justify-content-end mt-3">
                        <button className="btn btn-secondary me-2">
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={handlePayment}
                        >
                          Make Payment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhysicianPaymentHistory;
